import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ImportedAccount } from "@common/schemas/domains/accounting/importedAccount.schema";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import { getInstitutionForName } from "@components/institution/resolveInstitutionIcon";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import styles from "./ImportedAccountCell.module.scss";

export const ImportedAccountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, ImportedAccount, string>) => {
        const account = row.original;
        const institutionName = account.detectedInstitutionName;
        const institution = getInstitutionForName(institutionName);

        return (
            <ViewTableCell>
                <div className={styles.accountCell}>
                    {institution ? (
                        <InstitutionIcon
                            institution={institution}
                            size="xs"
                            label={institutionName ?? undefined}
                        />
                    ) : (
                        <InstitutionIcon size="xs" />
                    )}
                    <span className={styles.accountName}>{account.name}</span>
                </div>
            </ViewTableCell>
        );
    },
);
ImportedAccountCell.displayName = "ImportedAccountCell";
